import React, { useState, useEffect } from "react";
import API from "../../Api/Api";
import endpoints from "../../Api/Endpoints";
import "./AdminChangePasswordModal.scss";

export default function AdminChangePasswordModal({ isOpen, onClose }) {
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [pwdLoading, setPwdLoading] = useState(false);
  const [pwdError, setPwdError] = useState("");
  const [pwdSuccess, setPwdSuccess] = useState("");

  useEffect(() => {
    if (!isOpen) {
      setOtpSent(false);
      setOtp("");
      setNewPassword("");
      setConfirmPassword("");
      setPwdError("");
      setPwdSuccess("");
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSendOtp = () => {
    setPwdError("");
    setPwdSuccess("");
    setPwdLoading(true);
    API.post(endpoints.ADMIN_SEND_OTP)
      .then(() => {
        setOtpSent(true);
        setPwdSuccess("OTP sent to your registered mobile number.");
      })
      .catch((err) => setPwdError(err?.response?.data?.message || "Failed to send OTP"))
      .finally(() => setPwdLoading(false));
  };

  const handleChangePassword = (e) => {
    e.preventDefault();
    setPwdError("");
    setPwdSuccess("");
    if (!otp.trim()) {
      setPwdError("Please enter OTP.");
      return;
    }
    if (!newPassword) {
      setPwdError("Please enter new password.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setPwdError("New password and confirm password do not match.");
      return;
    }
    if (newPassword.length < 6) {
      setPwdError("Password must be at least 6 characters.");
      return;
    }
    setPwdLoading(true);
    API.post(endpoints.ADMIN_CHANGE_PASSWORD, {
      otp: otp.trim(),
      newPassword,
      confirmPassword,
    })
      .then((res) => {
        setPwdSuccess(res?.data?.message || "Password changed. Please login again.");
        setTimeout(() => {
          window.location.href = "/";
        }, 2000);
      })
      .catch((err) => setPwdError(err?.response?.data?.message || "Failed to change password"))
      .finally(() => setPwdLoading(false));
  };

  return (
    <div className="admin_pwd_modal_overlay" onClick={onClose} role="presentation">
      <div className="admin_pwd_modal admin_pwd_modal--sheet" onClick={(e) => e.stopPropagation()}>
        <div className="admin_pwd_modal_top">
          <h3>Change Password</h3>
          <button type="button" className="admin_pwd_modal_close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <p className="admin_pwd_hint">We will send an OTP to your registered mobile number to verify.</p>
        {!otpSent ? (
          <button type="button" className="admin_pwd_send_otp_btn" onClick={handleSendOtp} disabled={pwdLoading}>
            {pwdLoading ? "Sending…" : "Send OTP"}
          </button>
        ) : (
          <form onSubmit={handleChangePassword} className="admin_pwd_form">
            <div className="admin_pwd_field">
              <label>OTP</label>
              <input
                type="text"
                inputMode="numeric"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 4))}
                maxLength={4}
              />
            </div>
            <div className="admin_pwd_field">
              <label>New Password</label>
              <input
                type="password"
                placeholder="New password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </div>
            <div className="admin_pwd_field">
              <label>Confirm Password</label>
              <input
                type="password"
                placeholder="Confirm password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </div>
            {pwdError && <div className="admin_pwd_err">{pwdError}</div>}
            {pwdSuccess && <div className="admin_pwd_ok">{pwdSuccess}</div>}
            <div className="admin_pwd_actions">
              <button type="button" className="admin_pwd_cancel" onClick={onClose}>
                Cancel
              </button>
              <button type="submit" className="admin_pwd_submit" disabled={pwdLoading}>
                {pwdLoading ? "Updating…" : "Change Password"}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
